import { render, staticRenderFns } from "./BaseQrScan.vue?vue&type=template&id=01937490&"
import script from "./BaseQrScan.vue?vue&type=script&lang=js&"
export * from "./BaseQrScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports